<template>
  <component
    :is="type"
    v-bind="$props"
    class="flex items-center justify-center text-sm rounded p-3 focus:outline-none"
    :class="{
      [$style['BaseButton--disabled']]: disabled,
      'bg-sh-primary text-white': color === 'primary',
      'bg-white text-grey-500': color === 'white',
      'bg-transparent text-black': color === 'transparent',
      'bg-white text-sh-primary underline': color === 'link'
    }"
    @click.capture="clickHandler"
  >
    <span class="xs:hidden">
      <slot />
    </span>
    <base-icon v-if="icon" :name="icon" size="sm" class="md:ml-2 xs:m-auto" />
  </component>
</template>
<script>
export default {
  name: 'BaseMobileButton',
  props: {
    color: {
      type: String,
      required: false,
      default: 'primary',
      validator: value =>
        ['link', 'primary', 'white', 'transparent'].includes(value)
    },
    type: {
      type: String,
      default: 'button',
      validator: value => value.match(/(span|div|button)/),
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    icon: {
      type: String,
      required: false,
      default: null
    }
  },
  methods: {
    clickHandler(event) {
      if (this.disabled) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }
};
</script>
<style lang="scss" module>
.BaseButton--disabled {
  opacity: 0.3;
  @apply pointer-events-none cursor-not-allowed;
}
</style>
